export const trackEvent = (name, entry) => {
  if (typeof window.gtag !== "function" || !entry) return;
  window.gtag("event", name, {
    question: entry.english_question.slice(0, 100),
    song: (entry.song || "").slice(0, 100),
    category: entry.category || "",
  });
};
